export default __webpack_public_path__ + "static/media/Wolf's Armbands of the Wicked Hearth.507a1700.jpg";